var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-login"},[_c('h1',{staticClass:"_page-title"},[_vm._v("Login")]),_c('div',{staticClass:"_page-content"},[_c('login-form',{attrs:{"redirect":_vm.redirect}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }